<template>
  <div v-if="isInitialized && partsTags.length" class="filters">
    <div class="filters-area">
      <h4>סינון תכונות</h4>
      <div class="overflow-y-auto">
        <div class="d-flex ga-2 tag-filters-area">
          <template v-if="partsTags && partsTags.length">
            <v-select
              v-for="groupTags in partsTags"
              :key="groupTags.name"
              :width="getIsMobile ? '100%' : '230px'"
              :style="{ maxWidth: '120px' }"
              :items="groupTags.values || []"
              multiple
              rounded="lg"
              :placeholder="groupTags.name"
              variant="outlined"
              density="compact"
              v-model="chipArrays[groupTags.name]"
              class="custom-select"
              @update:model-value="
                (val) => handleSelectionUpdate(groupTags.name, val)
              "
            >
              <template v-slot:selection="{ index }">
                <span
                  v-if="index === 0"
                  class="text-grey text-caption align-self-center"
                  >({{ (chipArrays[groupTags.name] || []).length }})</span
                >
              </template>
            </v-select>
          </template>
          <p class="filters-not-found" v-else>לא נמצאו תכונות</p>
        </div>
      </div>
      <div class="d-flex ga-2 flex-wrap mb-5">
        <template
          v-for="(chipArray, chipArrayKey) in chipArrays"
          :key="chipArrayKey"
        >
          <template v-if="Array.isArray(chipArray)">
            <v-chip
              v-for="chipValue in chipArray"
              :key="`${chipArrayKey}-${chipValue}`"
              closable
              color="#BD9478"
              rounded="sm"
              @click:close="removeChip(chipArrayKey, chipValue)"
              >{{ chipValue }}</v-chip
            >
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FiltersComponent",

  data() {
    return {
      isInitialized: false,
      chipArrays: {},
      unwatchRoute: null,
    };
  },

  computed: {
    ...mapGetters({
      getIsMobile: "isMobile",
      partsTags: "Category/getPartsTags",
    }),
  },

  created() {
    this.initDynamicChipArrays();
  },

  mounted() {
    this.initializeFromQuery();

    // Setup route watcher
    this.unwatchRoute = this.$watch(
      () => this.$route.query,
      (newQuery) => {
        Object.keys(this.chipArrays).forEach((key) => {
          if (!newQuery[key]) {
            this.chipArrays[key] = [];
          }
        });
      },
      { deep: true }
    );

    this.isInitialized = true;
  },

  unmounted() {
    // Cleanup watcher
    if (this.unwatchRoute) {
      this.unwatchRoute();
    }
  },

  methods: {
    async initDynamicChipArrays() {
      if (this.partsTags?.length) {
        this.partsTags.forEach((groupTags) => {
          if (!this.chipArrays[groupTags.name]) {
            this.chipArrays[groupTags.name] = [];
          }
        });
      }
    },

    initializeFromQuery() {
      const query = this.$route.query;
      if (this.partsTags?.length) {
        this.partsTags.forEach((groupTags) => {
          const queryValue = query[groupTags.name];
          // Replace $set with direct assignment for Vue 3
          this.chipArrays[groupTags.name] = queryValue
            ? queryValue.split(",")
            : [];
        });
      }
    },

    removeChip(type, value) {
      if (this.chipArrays[type]) {
        this.chipArrays[type] = this.chipArrays[type].filter(
          (item) => item !== value
        );
        this.updateQuery();
      }
    },

    handleSelectionUpdate(type, newValue) {
      this.chipArrays[type] = newValue || [];
      this.updateQuery();
    },

    updateQuery() {
      delete this.$route.query?.page;
      const query = { ...this.$route.query };

      Object.entries(this.chipArrays).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length) {
          query[key] = value.join(",");
        } else {
          delete query[key];
        }
      });

      this.$router.push({ query }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
      this.$emit("reloadInfiniteScroll");
    },
  },

  watch: {
    partsTags: {
      handler(newPartsTags) {
        if (newPartsTags?.length) {
          this.initDynamicChipArrays();
          this.initializeFromQuery();
        }
      },
      immediate: true,
    },
    "$route.query": {
      handler() {
        if (this.isInitialized) {
          this.initializeFromQuery();
        }
      },
      immediate: true,
      deep: true,
    },
    chipArrays: {
      handler(newChipArrays) {
        if (this.isInitialized) {
          // Force UI update
          this.$nextTick(() => {
            Object.keys(newChipArrays).forEach((key) => {
              if (this.$refs[key]) {
                this.$refs[key].validate();
              }
            });
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.filters {
  .v-field--dirty {
    &:has(.v-field__outline__end) {
      .v-field__outline__end {
        border: unset !important;
      }
    }
    &:has(.v-field__outline__start) .v-field__outline__start {
      border-top-width: 0;
      border-bottom-width: 0;
      border-inline-start-width: 0;
    }
  }
  .v-field--dirty {
    border: 2px solid $primaryColor;
  }
  .v-field__input:not(.v-field--dirty) {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>

<style scoped lang="scss">
.filters-not-found {
  width: max-content;
  font-size: 16px;
  color: grey;
}
.filters {
  // width: 450px;
  .filters-area {
    h4 {
      margin-bottom: 10px;
      display: inline;
    }
  }
  .tag-filters-area {
    width: 500px;
  }
  .overflow-y-auto::-webkit-scrollbar {
    width: 4px; /* Adjust the width */
  }

  .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }

  .overflow-y-auto::-webkit-scrollbar-track {
    background: transparent;
  }

  .overflow-y-auto {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  }
}
.isMobile {
  .filters {
    width: 100%;
  }
}
</style>
